// src/controllers/empresaController.js

import { getEmpresas, createEmpresa, updateEmpresa, deleteEmpresa } from '../models/empresaModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

// Obtener lista de empresas paginadas
export async function fetchEmpresas(page, perPage) {
  try {
    const response = await getEmpresas(page, perPage);
    return {
      empresa: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching empresas:", error);
    Swal.fire('Error', 'No se pudieron cargar las empresas', 'error');
    return null;
  }
}

// Guardar o actualizar una empresa
export async function saveEmpresa(empresa, currentEmpresaId) {
  try {
    if (currentEmpresaId) {
      await updateEmpresa(currentEmpresaId, empresa);
      toasts.add({
        title: 'Éxito',
        description: 'Empresa actualizada exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createEmpresa(empresa);
      toasts.add({
        title: 'Éxito',
        description: 'Empresa creada exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving empresa:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar la empresa',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

// Eliminar una empresa
export async function removeEmpresa(id) {
  try {
    await deleteEmpresa(id);
    toasts.add({
      title: 'Éxito',
      description: 'Empresa eliminada exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting empresa:", error);
    Swal.fire('Error', 'No se pudo eliminar la empresa', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'empresa'
export function subscribeToEmpresas(searchQuery, handleSearch) {
  pb.collection('empresa').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromEmpresas() {
  pb.collection('empresa').unsubscribe('*');
}

// Buscar empresas por nombre comercial con paginación
export async function searchEmpresas(query, page = 1, perPage = 10) {
  const response = await pb.collection('empresa').getList(page, perPage, {
    filter: `nombre_comercial ~ "${query}"`,
  });
  return {
    empresa: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}
